import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import { ResponseGridView } from '../view/ResponseGridView';
import { ResponseGridWebComponent } from '../component/ResponseGridWebComponent';
import { ResponseGridRepository } from '../repository/ResponseGridRepository';
import responseGridTemplate from '../view/template';
import { Events, ResponseGridViewData } from '../types';
import { SmartViewEvents, SmartViewItemConfiguration } from '../../../grid/genericGridSmartViews/types';

export class ResponseGridController extends BaseWebComponentController {
  public component: ResponseGridWebComponent;
  public dataRepository: ResponseGridRepository;
  public view: ResponseGridView;

  public constructor(component: ResponseGridWebComponent) {
    super(component);

    this.initialSetup({
      dataRepositoryConstructor: ResponseGridRepository,
      viewConstructor: ResponseGridView,
      viewTemplate: responseGridTemplate,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$smartViews,
        event: SmartViewEvents.SMART_VIEW_SELECTED,
        callback: this.onSmartViewSelect,
      },
      {
        element: this.view.dom.$gridView,
        event: Events.UPDATE_STATUS,
        callback: this.onUpdateStatus,
      },
      {
        element: this.view.dom.$gridView,
        event: Events.OPEN_CUSTOM_RULE_DETAILS_PANEL,
        callback: this.onOpenCustomRuleDetailsPanel,
      },
    ];
  }

  public async getDataForView(): Promise<ResponseGridViewData> {
    return this.dataRepository.getDataForView(this.component.incidentId);
  }

  private async onSmartViewSelect(event: WebComponentEvent): Promise<void> {
    const smartView = event.detail.smartViewConfiguration as SmartViewItemConfiguration;

    if (smartView._id === this.view.dom.$gridView.viewId) {
      return;
    }

    await this.view.dom.$smartViews.controller?.updateActiveViewId(smartView._id);
    await this.view.buildGridView(smartView);
  }

  private async onUpdateStatus(event: WebComponentEvent): Promise<void> {
    try {
      await this.dataRepository.updateStatus(event.detail.id, event.detail.status);

      this.view.showUpdateStatusActionSuccessToast(event.detail.status);
    } catch (error: any) {
      this.view.showUpdateStatusActionFailedToast();
    } finally {
      await this.view.dom.$gridView.controller?.handleGridItemsLoad();
    }
  }

  private async onOpenCustomRuleDetailsPanel(event: WebComponentEvent): Promise<void> {
    try {
      const customRuleDetails = await this.dataRepository.getCustomRuleDetails(event.detail.id);

      this.view.openCustomRuleDetailsSidePanel(customRuleDetails);
    } catch (error: any) {
      this.view.showCustomRuleDetailsFailedToLoadToast();
    }
  }

}
